(ns common.specs.resource
  (:require [clojure.spec.alpha :as s]
            [spec-tools.data-spec :as ds]
            [common.specs.universal]))

(s/def :resource/uuid :common/uuid)
(s/def :resource/owner-uuid :common/uuid)

(s/def ::resource
  (s/keys :req-un [:resource/uuid]))


(s/def :resource/valid-status #{"waiting for upload" "copying" "transcoding"
                                "converting" "complete" "failed" "warning"})

(def ^:private common-keys
  #:resource{:description string?
             :download-key string? ;; File Name
             :duration number?
             :openai-file-id (ds/maybe string?)
             :file-name string?
             :file-size number?
             :file-type string?
             :learning-objective (ds/maybe {:learning-objective/uuid :common/uuid})
             :name string? ;;file name
             :page-count int?
             :page-dimensions [{:height pos-int?
                                :width pos-int?}]
             :public boolean?
             :source-key string? ;;file name
             :status :resource/valid-status
             :viewer-key string?}) ;;file name

(def db-item->resource-spec
  (ds/spec {:name ::db-item->resource
            :keys-default ds/opt
            :spec (merge common-keys
                         #:resource{:failed? boolean?
                                    :processing? boolean?
                                    :activity-uuid :common/uuid})}))


(def resource->db-item-spec
  (ds/spec {:name ::resource->db-item
            :keys-default ds/opt
            :spec (merge common-keys
                         {(ds/req :resource/uuid) :common/uuid
                          :resource/activity {:activity/uuid :common/uuid}})}))
